import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, exhaustMap, filter, map, of, withLatestFrom } from 'rxjs';
import { EvaluationSurveyApiService } from '../services/evaluation-survey-api.service';
import * as EvaluationSurveyActions from './evaluation-survey.actions';
import { selectEvaluationSurveyLoaded } from './evaluation-survey.selectors';

@Injectable()
export class EvaluationSurveyEffects {
  private readonly actions$ = inject(Actions);
  private readonly api = inject(EvaluationSurveyApiService);
  private readonly store = inject(Store);

  load$ = createEffect(() => this.actions$.pipe(
    ofType(EvaluationSurveyActions.loadEvaluationSurvey),
    withLatestFrom(this.store.select(selectEvaluationSurveyLoaded)),
    filter(([{ refresh }, loaded]) => refresh === true || !loaded),
    exhaustMap(([{ refresh }]) =>
      this.api.readAll({ refresh: refresh ?? false }).pipe(
        map(data => EvaluationSurveyActions.loadEvaluationSurveySuccess({
          data: Array.isArray(data) ? data : [],
        })),
        catchError(error => of(EvaluationSurveyActions.loadEvaluationSurveyFailure({ error }))),
      ),
    ),
  ));

  refresh$ = createEffect(() => this.actions$.pipe(
    ofType(EvaluationSurveyActions.refreshEvaluationSurvey),
    map(() => EvaluationSurveyActions.loadEvaluationSurvey({ refresh: true })),
  ));
}
